let excessPaymentsCols = [
    {
        key: 'displayLabel',
        display: 'Gadget'
    },
    {
        key: 'processorToken',
        display: 'Token'
    },
    {
        key: 'cardPaymentStatusLabel',
        display: 'Status'
    },
    {
        key: 'cardPaymentCurrencyCode',
        display: 'Currency'
    },
    {
        key: 'excess',
        display: 'Amount'
    },
    {
        key: 'cardPaymentDateAsLocalTime',
        display: 'Attempted Date'
    }
]

export { excessPaymentsCols }